export const UPDATE_MOBILE_DRAWER_VISIBILITY = 'UPDATE_MOBILE_DRAWER_VISIBILITY';
export const updateMobileDrawerVisibility = isOpen => ({
  type: UPDATE_MOBILE_DRAWER_VISIBILITY,
  payload: isOpen,
});
